import { useContext, useEffect, useState } from "react";
import context from "../../store/context";

import ChannelPreferanceCard from "../cards/ChannelPreferance";
import ChannelPreferanceShimmer from "../cards/ChannelPreferanceShimmer";

// icons
import TelegramIcon from "../icons/social/Telegram";
import MessageIcon from "../icons/Message";
import EmailIcon from "../icons/Email";

const ChannelPreferance = () => {
  const userToken = sessionStorage.getItem("token");
  const { channels, setChannels, userInfo } = useContext(context);
  const { email, sms, telegram } = channels;

  const [send, setSend] = useState(false);

  const saveChange = (value, id) => {
    setSend(true);
    if (id === "telegramToggle") {
      setChannels({ ...channels, telegram: value ? 1 : 0 });
    } else if (id === "smsToggle") {
      setChannels({ ...channels, sms: value ? 1 : 0 });
    } else {
      setChannels({ ...channels, email: value ? 1 : 0 });
    }
  };

  useEffect(() => {
    if (send) {
      var headers = new Headers();
      headers.append("X-XSRF-TOKEN", "csrf-cookie");
      headers.append("Accept", "application/json");
      headers.append("Authorization", `Bearer ${userToken}`);

      var requestOptions = {
        method: "POST",
        headers: headers,
        redirect: "follow",
      };

      fetch(
        `https://api.ichereta.com/api/client/setting/save-channel?SMS=${sms}&email=${email}&telegram=${telegram}`,
        requestOptions
      )
        .then((response) => {
          if (response.status === 401) {
            sessionStorage.clear();
            window.location.href = "/";
          }
          return response.json();
        })
        .then((result) => {
          // console.log(result);
        })
        .catch((error) => {
          console.log("error", error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sms, email, telegram]);

  return (
    <div className="w-full bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-[0_2px_10px_rgba(61,89,132,0.06)]">
      {telegram !== "" ? (
        <ChannelPreferanceCard
          id="telegramToggle"
          isOn={telegram}
          onClick={saveChange}
          title="Telegram Notification"
          icon={<TelegramIcon styles="w-4 h-4" />}
          description={
            <p>
              Telegram Notification Will be sent to your registered phone
              <span className="font-semibold text-gray-700"> {userInfo.phone}</span>
            </p>
          }
        />
      ) : (
        <ChannelPreferanceShimmer />
      )}

      {sms !== "" ? (
        <ChannelPreferanceCard
          id="smsToggle"
          isOn={sms}
          onClick={saveChange}
          title="SMS Notification"
          icon={<MessageIcon styles="w-5 h-5" />}
          description={
            <p>
              Daily SMS Notification Will be sent to your registered number
              <span className="font-semibold text-gray-700"> {userInfo.phone}</span>
            </p>
          }
        />
      ) : (
        <ChannelPreferanceShimmer />
      )}
      {email !== "" ? (
        <ChannelPreferanceCard
          id="emailToggle"
          isOn={email}
          onClick={saveChange}
          title="Email Notification"
          buttonName="Change Email"
          icon={<EmailIcon styles="w-5 h-5" />}
          last
          description={
            <p>
              Daily Email Notification Will be sent to your registered email
              <span className="font-semibold text-gray-700"> {userInfo.email}</span>
            </p>
          }
        />
      ) : (
        <ChannelPreferanceShimmer last />
      )}
    </div>
  );
};

export default ChannelPreferance;
